export default __webpack_public_path__ + "static/media/GSSDC Debate 2020 RunnersUp.605eef10.webp";